import { render } from "./LitigationQuestionBuilder.vue?vue&type=template&id=715873f4&scoped=true"
import script from "./LitigationQuestionBuilder.vue?vue&type=script&lang=js"
export * from "./LitigationQuestionBuilder.vue?vue&type=script&lang=js"

import "./LitigationQuestionBuilder.vue?vue&type=style&index=0&id=715873f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715873f4"]])

export default __exports__